// Faelligkeit einer Abrechnung, EINE Lesart fuer alle Flaechen (#1119):
// Einrichtungsliste (Chip und Arbeitsliste "Heute abzurechnen") und die
// Dashboard-Kachel "Fällige Abrechnungen" urteilten vorher unterschiedlich.
//
// "ja" = faellig (Datum heute oder frueher), "nein" = spaeter faellig,
// "unbekannt" = kein brauchbares Datum. next_settlement ist ein String im
// Format TT.MM.JJJJ und steht auf "-", wenn zur Einrichtung gar kein
// location_base existiert.
export function settlementState(item) {
  var raw = item.next_settlement;

  if (!raw || typeof raw !== 'string') return 'unbekannt';

  var parts = raw.split('.');
  if (parts.length !== 3) return 'unbekannt';

  var day = parseInt(parts[0], 10);
  var month = parseInt(parts[1], 10);
  var year = parseInt(parts[2], 10);

  if (!day || !month || !year) return 'unbekannt';

  var settlement = new Date(year, month - 1, day);
  if (isNaN(settlement.getTime())) return 'unbekannt';

  // Rueckprobe gegen die stille Korrektur von JS: new Date(2026, 1, 31) ist
  // der 03.03., nicht der 31.02. Ohne diese Zeile waere ein Unsinnsdatum ein
  // gueltiges Faelligkeitsdatum.
  if (
    settlement.getDate() !== day ||
    settlement.getMonth() !== month - 1 ||
    settlement.getFullYear() !== year
  ) {
    return 'unbekannt';
  }

  var today = new Date();
  today.setHours(0, 0, 0, 0);
  settlement.setHours(0, 0, 0, 0);

  return settlement <= today ? 'ja' : 'nein';
}
